export type FeatureSupport = {
  ok: boolean;
  missing: string[];
};

export function detectFeatures(): FeatureSupport {
  const missing: string[] = [];
  if (typeof crypto === 'undefined' || !crypto.getRandomValues) {
    missing.push('crypto.getRandomValues');
  }
  if (typeof crypto === 'undefined' || !crypto.subtle) {
    missing.push('Web Crypto (crypto.subtle)');
  }
  if (typeof WebAssembly === 'undefined') {
    missing.push('WebAssembly');
  }
  if (typeof Worker === 'undefined') {
    missing.push('Web Workers');
  }
  return { ok: missing.length === 0, missing };
}
